'use client'

import { useTranslations } from 'next-intl'
import AppLink from '@/components/elementary/AppLink'
import { Paragraph } from '@/components/typography/Paragraph'
import { isValueEqualToPathname, usePathname } from '@/lib/navigation'
import { cn } from '@/lib/styles'
import type { GridCategoryNavigationData } from '@/types/general'

export function SidePanelCategoryNavigation({
	topCategories,
	restCategories,
	additionalLink,
}: GridCategoryNavigationData) {
	const t = useTranslations('categoryFilter')
	const pathname = usePathname()
	return (
		<div className="lg:flex hidden flex-col gap-8 w-full lg:max-w-74.5">
			{Array.isArray(topCategories) && topCategories?.length > 0 ? (
				<nav>
					<ul className="flex flex-col gap-3">
						{topCategories?.map((category) => {
							return (
								<li key={category.documentId}>
									<AppLink
										size="none"
										variant="ghost"
										href={category.link}
										scroll={false}
										className={cn(
											'flex justify-start',
											isValueEqualToPathname(category.fullPath, pathname) &&
												'text-brand-salmon font-bold',
										)}
									>
										{category?.title}
									</AppLink>
								</li>
							)
						})}
					</ul>
				</nav>
			) : null}

			<div className="flex flex-col gap-4">
				<Paragraph fontSize="headingSmall">{t('categories')}</Paragraph>
				<nav>
					<ul className="flex flex-col gap-3">
						{restCategories?.map((category) => {
							return (
								<li key={category.documentId}>
									<AppLink
										size="none"
										variant="ghost"
										href={category.link}
										scroll={false}
										className={cn(
											'flex justify-start',
											isValueEqualToPathname(category.fullPath, pathname) &&
												'text-brand-salmon font-bold',
										)}
									>
										{category?.title}
									</AppLink>
								</li>
							)
						})}
					</ul>
				</nav>
			</div>

			{additionalLink?.href && (
				<div className="border-t border-neutral-light-40 pt-9">
					<AppLink
						href={additionalLink.href}
						openExternalInNewTab={additionalLink.newTab ?? false}
						size="none"
						variant="ghost"
					>
						{additionalLink.label}
					</AppLink>
				</div>
			)}
		</div>
	)
}
